<template>
    <div>
        <v-btn
            size="small"
            elevation="0"
            class="mx-1"
            rounded
            color="ternary"
            @click="openDialog()"
        >
            <v-icon size="large" left class="pr-2">$fa-plus</v-icon> un régime
        </v-btn>
        <oss-dialog v-model="dialog" title="Ajouter un régime" @valid="closeDialog" width="40vw">
            <div style="width: 100%">
                <v-virtual-scroll
                    :benched="20"
                    :items="allTaxSystems"
                    height="500"
                    item-height="64"
                >
                    <template v-slot:default="{ item }">
                        <v-list-item
                            :key="item"
                            class="d-flex align-center mb-1"
                            border="sm"
                            variant="outlined"
                            rounded="xl"
                            density="comfortable"
                            style="height: 60px"
                        >
                            <template v-slot:prepend>
                                <v-checkbox
                                    :model-value="inputTaxSystemsSync.includes(item)"
                                    @update:model-value="selectTaxSystems(item)"
                                    color="primary"
                                    class="pr-3 pa-0"
                                />
                            </template>
                            {{ title(item) }}
                        </v-list-item>
                    </template>
                </v-virtual-scroll>
            </div>
        </oss-dialog>
    </div>
</template>

<script lang="ts">
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Model } from "vue-facing-decorator";

@Component
export class ScopeActionsAddTaxSystem extends Vue {
    @Model({ name: "taxSystems" }) inputTaxSystemsSync!: string[];

    dialog: boolean = false;
    company: any = null;

    get currentCompany() {
        return this.$store.state.user.company;
    }

    get allTaxSystems() {
        return [
            "RS_IS",
            "RS_IR",
            "RN_IS",
            "RN_IR",
            // "BIC",
            "BNC",
            "RF",
        ];
    }

    openDialog() {
        this.dialog = true;
    }

    closeDialog() {
        this.dialog = false;
    }

    selectTaxSystems(taxSystem) {
        const isSelected = this.isSelectedActivities(taxSystem);
        if (isSelected) {
            const taxSystemIndex = this.inputTaxSystemsSync.findIndex((t) => t === taxSystem);
            if (taxSystemIndex !== -1) {
                this.inputTaxSystemsSync.splice(taxSystemIndex, 1);
            }
        } else {
            this.inputTaxSystemsSync.push(taxSystem);
        }
    }

    isSelectedActivities(taxSystem) {
        const isSelected = this.inputTaxSystemsSync.find((t) => t === taxSystem);
        return isSelected;
    }

    checkboxValueComparator(a: any, b: any) {
        return a === b;
    }

    title(system) {
        switch (system) {
            case "RS_IS":
                return "BIC régime simplifié à l'Impôt sur les Sociétés";
            case "RS_IR":
                return "BIC régime simplifié à l'Impôt sur le Revenu";
            case "RN_IS":
                return "BIC régime normal à l'Impôt sur les Sociétés";
            case "RN_IR":
                return "BIC régime normal à l'Impôt sur le Revenu";
            case "BIC":
                return "BIC";
            case "BNC":
                return "BNC";
            case "RF":
                return "RF";
            default:
                break;
        }
    }
}

export default toNative(ScopeActionsAddTaxSystem);
</script>
